"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheet = void 0;
var react_1 = __importStar(require("react"));
var ApprovalSheetManagement_1 = require("../../features/approval-sheet-management/ApprovalSheetManagement");
var ApprovalSheetContext_1 = require("../../context/ApprovalSheetContext");
var utils_1 = require("../../utils");
var features_1 = require("../../features");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var styles_1 = require("@material-ui/core/styles");
var ApprovalSheetHeader_1 = require("./components/ApprovalSheetHeader");
var useApprovalSheetStyles = styles_1.makeStyles(function () {
    return {
        item: {
            width: '100%',
        },
    };
});
exports.ApprovalSheet = function () {
    var _a = react_1.useContext(ApprovalSheetContext_1.ApprovalSheetContext), sheet = _a.sheet, currentUserId = _a.currentUserId, isAdmin = _a.isAdmin;
    var statusType = sheet.statusType;
    var isManagementAllowed = isAdmin || sheet.ownerUserId === currentUserId;
    var isNotStartStatus = statusType ? utils_1.isNotStartApprovalStatus(statusType) : false;
    var isEndStatus = statusType ? utils_1.isEndApprovalStatus(statusType) : false;
    var classes = useApprovalSheetStyles();
    return (react_1.default.createElement(core_1.ExpansionPanel, { defaultExpanded: !isEndStatus },
        react_1.default.createElement(core_1.ExpansionPanelSummary, { expandIcon: react_1.default.createElement(icons_1.ExpandMore, null) },
            react_1.default.createElement(ApprovalSheetHeader_1.ApprovalSheetHeader, { stateCode: statusType })),
        react_1.default.createElement(core_1.ExpansionPanelDetails, null,
            react_1.default.createElement(core_1.Grid, { container: true, direction: "column", spacing: 6 },
                isManagementAllowed && (react_1.default.createElement(core_1.Grid, { item: true, className: classes.item },
                    react_1.default.createElement(ApprovalSheetManagement_1.ApprovalSheetManagement, null))),
                isNotStartStatus && (react_1.default.createElement(core_1.Grid, { item: true, className: classes.item },
                    react_1.default.createElement(features_1.ApprovalSheetResolutionsTable, null)))))));
};
